/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, TextStyle, DisplayText } from '@shopify/polaris';
import { Frame } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import * as setupActions from 'actions/setup-actions';
import { routes } from 'src/routes';
import vertical from 'src/assets/images/install/layout-vertical.png';
import horizontal from 'src/assets/images/install/layout-horizontal.png';
import { LayoutCard } from 'src/components/views/installation/1-select-layout/layout-card';
import { StepProgress } from 'src/components/views/installation/step-progress';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import type { Props } from './1-select-layout.type';

import history from 'src/routes/history';

type ComposedProps = Props & WithI18nProps;
// DONE
class SelectLayout extends Component<ComposedProps> {
  componentWillReceiveProps(nextProps) {
    const { success, status } = nextProps;

    if (success && status === 'OK') {
      history.push(routes.initializing.view());
    }

    if (nextProps.loading === true && this.props.loading === false) {
      startSABLoading();
    }

    if (nextProps.loading === false && this.props.loading === true) {
      stopSABLoading();
    }
  }

  render() {
    const { i18n } = this.props;
    return (
      <div className="BC-AnotherLayout">
        <Frame>
          {/* <div className="Polaris-Page">
            <div className="Polaris-Page-Header" style={{ marginBottom: '-1rem' }}>
              <DisplayText size="extraLarge">
                {i18n.translate('AdminHTML.Installation.OneDashSelectLayout.displayText1')}
              </DisplayText>
            </div>
          </div> */}

          <Page
            title={i18n.translate('AdminHTML.Installation.OneDashSelectLayout.pageTitle')}
            primaryAction={
              <div className="step-progress-initializing">
                <StepProgress step={2} />
              </div>
            }>
            <Layout>
              <Layout.Section>
                <DisplayText size="small">
                  <span className="text-installation">
                    {i18n.translate(
                      'AdminHTML.Installation.OneDashSelectLayout.displayText2_Content',
                      {
                        t: (
                          <TextStyle variation="strong">
                            {i18n.translate(
                              'AdminHTML.Installation.OneDashSelectLayout.displayText2_Content_t'
                            )}
                          </TextStyle>
                        )
                      }
                    )}{' '}
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Installation.OneDashSelectLayout.textStyle')}
                    </TextStyle>
                  </span>
                </DisplayText>
              </Layout.Section>

              <LayoutCard
                title={i18n.translate(
                  'AdminHTML.Installation.OneDashSelectLayout.layoutCard1_Title'
                )}
                src={vertical}
                buttonId="select-vertical-layout"
                actionButton={() => this.handleSelectLayout('v')}
              />

              <LayoutCard
                title={i18n.translate(
                  'AdminHTML.Installation.OneDashSelectLayout.layoutCard2_Title'
                )}
                src={horizontal}
                buttonId="select-horizontal-layout"
                actionButton={() => this.handleSelectLayout('h')}
              />
            </Layout>
          </Page>
        </Frame>
      </div>
    );
  }

  // Handle select layout action
  handleSelectLayout = (layoutType: string) => {
    const { autoSetupTheme } = this.props;
    const requestParams = { layout: layoutType };

    autoSetupTheme({ requestParams });
  };
}

const mapStateToProps = (state, props) => ({
  loading: state.setup.autoSetupThemeLoading,
  success: state.setup.autoSetupThemeSuccess,
  error: state.setup.error,
  code: state.setup.code,
  status: state.setup.status
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  autoSetupTheme: (body: Object) =>
    dispatch(setupActions.autoSetupTheme(body, undefined, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SelectLayout));
